import { render } from "./discountsView.vue?vue&type=template&id=f57f696e"
import script from "./discountsView.vue?vue&type=script&lang=js"
export * from "./discountsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__